import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const tiers = [{
  name: 'Recon',
  price: '149',
  description: 'For solo consultants and boutique agencies.',
  features: ['Up to 5 ad accounts', '3 custom dashboards', 'Weekly automated reports', 'Standard email support'],
  popular: false
}, {
  name: 'Vanguard',
  price: '449',
  description: 'For growing agencies scaling their operations.',
  features: ['Up to 25 ad accounts', 'Unlimited dashboards', 'Daily automated reports', 'Real-time anomaly detection', 'Priority support'],
  popular: true
}, {
  name: 'Citadel',
  price: '1,199',
  description: 'For enterprise agencies needing full control.',
  features: ['Unlimited ad accounts', 'Custom attribution models', 'Dedicated success manager', '99.9% SLA guarantee', 'Full API access'],
  popular: false
}];
export function PricingSection() {
  return <section id="pricing" className="py-24 px-6 bg-navy-900" data-id="element-244">
      <div className="max-w-7xl mx-auto" data-id="element-245">
        <div className="text-center mb-16" data-id="element-246">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-247">
            Transparent Pricing, No Hidden Fees
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto" data-id="element-248">
            Predictable costs that scale with your agency's growth.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-249">
          {tiers.map((tier, index) => <motion.div key={tier.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`relative bg-navy-800 rounded-2xl p-8 flex flex-col ${tier.popular ? 'border-2 border-accent-teal shadow-[0_0_30px_rgba(0,212,170,0.1)]' : 'border border-navy-700'}`} data-id="element-250">
              {tier.popular && <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-accent-teal text-navy-900 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider" data-id="element-251">
                  Most Popular
                </div>}

              <div className="mb-8" data-id="element-252">
                <h3 className="text-xl font-semibold text-white mb-2" data-id="element-253">
                  {tier.name}
                </h3>
                <p className="text-sm text-gray-400 h-10" data-id="element-254">{tier.description}</p>
              </div>

              <div className="mb-8" data-id="element-255">
                <div className="flex items-baseline gap-1" data-id="element-256">
                  <span className="text-2xl text-gray-400 font-mono" data-id="element-257">€</span>
                  <span className="text-5xl font-bold text-white font-mono" data-id="element-258">
                    {tier.price}
                  </span>
                  <span className="text-gray-400" data-id="element-259">/mo</span>
                </div>
              </div>

              <ul className="space-y-4 mb-8 flex-grow" data-id="element-260">
                {tier.features.map((feature, fIndex) => <li key={fIndex} className="flex items-start gap-3 text-sm text-gray-300" data-id="element-261">
                    <CheckIcon className="w-5 h-5 text-accent-teal shrink-0" data-id="element-262" />
                    {feature}
                  </li>)}
              </ul>

              <button className={`w-full py-3 rounded-md font-semibold transition-colors ${tier.popular ? 'bg-accent-teal text-navy-900 hover:bg-accent-teal/90' : 'bg-navy-700 text-white hover:bg-navy-600'}`} data-id="element-263">
                Start 14-Day Trial
              </button>
            </motion.div>)}
        </div>
      </div>
    </section>;
}